<template>
  <de-layout-content>
    <div class="venues">

      <!-- <el-form :model="form" ref="queryForm" :inline="true" class="ant-advanced-search-form">
        <el-form-item label="机构名称">
          <el-input v-model="form.name" placeholder="输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="联系人信息">
          <el-input v-model="form.contactInfo" placeholder="输入联系人/联系电话"></el-input>
        </el-form-item>
        <el-form-item label="所在城市">
          <el-cascader v-model="value" v-if="showFormArea" :options="formTreeValue" @change="formTreeValue"></el-cascader>
        </el-form-item>

        <el-form-item label="申请时间">
          <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间">
          </el-date-picker>
        </el-form-item>

      </el-form> -->

      <a-form :model="form" layout="inline" class="ant-advanced-search-form" size="small">
        <a-form-item label="机构名称">
          <a-input allowClear v-model="form.name" placeholder="输入机构名称" />
        </a-form-item>
        <!-- <a-form-item label="状态" class="width-normal">
        <a-select
          allowClear
          ref="select"
          v-model:value="form.examineStatus"
          placeholder="选择状态"
        >
          <a-select-option value="1">待审批</a-select-option>
          <a-select-option value="2">已通过</a-select-option>
          <a-select-option value="3">已拒绝</a-select-option>
        </a-select>
      </a-form-item> -->
        <a-form-item label="联系人信息">
          <a-input allowClear v-model="form.contactInfo" placeholder="输入联系人/联系电话" />
        </a-form-item>
        <a-form-item label="所在城市">
          <AdministrativeArea @callBackTreeValue="formTreeValue" v-if="showFormArea" />
        </a-form-item>
        <a-form-item label="申请时间">
          <a-range-picker v-model="form.addDate" format="YYYY-MM-DD" />
        </a-form-item>

        <a-form-item>
          <a-space :size="10">
            <el-button size="small" icon="el-icon-search" type="primary" @click="btnOperation('search')">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" type="default" @click="btnOperation('reload')">重置</el-button>
            <div class="approvalButton">
              <el-button size="mini" type="primary" @click="btnOperation('approved')"
                icon="el-icon-check">审批通过</el-button>
              <el-button size="mini" type="danger" plain @click="btnOperation('refuse')" icon="el-icon-close"
                style="margin-left: 10px;">审批拒绝</el-button>
            </div>
          </a-space>
        </a-form-item>
      </a-form>
    </div>

    <!-- 数据列表 -->
    <div>
      <!-- 数据列表 -->
      <el-table element-loading-text="加载中" :data="dataSource" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
        <el-table-column label="序号" align="center" type="index" />
        <el-table-column label="机构名称" align="center" prop="name" />
        <el-table-column label="审批状态" align="center" prop="examineStatus">
          <template slot-scope="scope">
            <span v-show="scope.row.examineStatus == 1" style="color: #ff9900">● 待审批</span>
            <span v-show="scope.row.examineStatus == 2" style="color: #19be6b">● 已通过</span>
            <span v-show="scope.row.examineStatus == 3" style="color: #f56c6c">● 已拒绝</span>
          </template>
        </el-table-column>
        <el-table-column label="所在城市" align="center" prop="addressName" />
        <el-table-column label="社会信用代码/注册号" align="center" prop="socialCreditCode">
          <template slot-scope="scope">
            {{ scope.row.socialCreditCode || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="center" prop="contactsName">
          <template slot-scope="scope">
            {{ scope.row.contactsName || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="联系电话" align="center" prop="contactsPhone">
          <template slot-scope="scope">
            {{ scope.row.contactsPhone || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" prop="createTime">
          <template slot-scope="scope">
            {{ scope.row.createTime | timestampFormatDate }}
            <!-- {{ scope.row.createTime ? moment(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss") : "" }} -->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button size="small" plain type="primary" @click="hallAddEdit('detail', scope.row)">详情</el-button>
            <el-popconfirm title="确定删除吗？该操作不会撤销" @confirm="handleDelete(scope.row)">
              <el-button slot="reference" size="small" type="danger" plain style="margin-left: 10px">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作2" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button size="small" plain type="primary" @click="handleEdit(scope.row)" >编辑</el-button>
              <el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
            </template>
          </el-table-column> -->
      </el-table>
      <pagination :total="total" :page.sync="form.page" :limit.sync="form.size" @pagination="getData" />

      <!-- <a-table rowKey="id" :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: getCheckboxProps, //是否禁用checkbox
          type: 'checkbox', //单选还是多选
        }" :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changeTable">
          <template v-slot:openStatus="openStatus">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="openStatus.record.openStatus"
              checked-children="正常" un-checked-children="禁用" @change="setOpenStatus(openStatus.record)" />
          </template>
          <template v-slot:examineStatus="examineStatus">
            <span v-show="examineStatus.text == 1" style="color: #ff9900">● 待审批</span>
            <span v-show="examineStatus.text == 2" style="color: #19be6b">● 已通过</span>
            <span v-show="examineStatus.text == 3" style="color: #f56c6c">● 已拒绝</span>
          </template>
          <template v-slot:tags="tags">
            <a-button type="primary" size="small" @click="hallAddEdit('detail', tags.record)">
              详情
            </a-button>
            <a-popconfirm title="确定删除吗？该操作不会撤销" ok-text="是" cancel-text="否" @confirm="handleDelete(tags.record)">
              <a-button type="primary" danger size="small"> 删除 </a-button>
            </a-popconfirm>
          </template>
        </a-table> -->
    </div>

    <!-- 审批(通过/拒绝)mode -->
    <a-modal v-model:visible="showApproved" :title="operationType == 'refuse' ? '审批拒绝' : '审批通过'"
             @ok="approved(operationType)" autocomplete="off" centered width="600px">
      <a-form ref="approvedRuls" :model="approvedForm" :rules="approvedRules">
        <a-form-item v-if="operationType != 'refuse'" label="有效期" name="validityPeriod">
          <a-date-picker
            v-model:value="approvedForm.startTime"
            type="datetime"
            placeholder="开始日期"
            :disabled-date="startDisabledDate"            style="width: 48%; margin-right: 4%;">
          </a-date-picker>
          <a-date-picker
            v-model:value="approvedForm.endTime"
            type="datetime"
            placeholder="结束日期"
            :disabled-date="endDisabledDate"            style="width: 48%;">
          </a-date-picker>
        </a-form-item>
        <a-form-item label="备注信息" has-feedback :rules="[
        {
          required: operationType == 'refuse' ? true : false,
          message: '请填写拒绝原因!',
        },
      ]">
          <a-textarea v-model:value="approvedForm.remark" show-count :maxlength="200" :rows="4" />
        </a-form-item>
        <span v-show="operationType == 'refuse'">拒绝入驻，需要填写拒绝原因</span>
      </a-form>
    </a-modal>

    <!-- 设置审批人 -->
    <a-modal v-model:visible="showSetExamineUser" title="设置审批人" @ok="setExamineUser(operationType)" autocomplete="off"
      centered width="500px">
      <a-form :model="examineUser" ref="examineUserRuls">
        <a-form-item label="审批人" name="userId" has-feedback :rules="[{ required: true, message: '请选择审批人!' }]">
          <a-select v-model:value="examineUser.userId" :options="examineUser.userOptions" placeholder="请选择审批人">
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 维护场馆 -->
    <a-modal v-model:visible="showHallEdit" title="场馆信息维护" centered @ok="maintainHall()" width="650px">
      <a-form :model="hallEditForm" name="basic" autocomplete="off" ref="hallRuls">
        <!--       :style="{ height: Cheight, overflow: 'hidden', 'overflow-y': 'auto' }" -->
        <a-form-item label="场馆名称" name="name" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请输入场馆名称!' }]">
          <a-input v-model:value="hallEditForm.name" disabled />
        </a-form-item>
        <a-form-item label="社会信用代码" name="socialCreditCode" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请输入社会信用代码!' }]">
          <a-input v-model:value="hallEditForm.socialCreditCode" disabled />
        </a-form-item>

        <a-form-item label="场馆面积(平方)" name="area" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请输入场馆面积(平方)!' }]">
          <a-input-number v-model:value="hallEditForm.area" style="width: 100%" placeholder="请输入场馆面积(平方)" />
        </a-form-item>
        <a-form-item label="可容纳人数" name="capacity" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请输入可容纳人数!' }]">
          <a-input-number style="width: 100%" v-model:value="hallEditForm.capacity" placeholder="请输入可容纳人数" />
        </a-form-item>
        <a-form-item label="所在地区" name="address" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请选择所在地区!' }]">
          <!-- hallEditForm.address -->
          <AdministrativeArea v-if="showHallEdit" @callBackTreeValue="hallFormTreeValue"
            :treeNodeVal="hallEditForm.address" />
        </a-form-item>
        <a-form-item name="detailAddress" label="详细地址" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请输入详细地址!' }]">
          <a-textarea v-model:value="hallEditForm.detailAddress" show-count :maxlength="200" :rows="2"
            placeholder="请输入详细地址" />
        </a-form-item>
        <a-form-item label="所属体育局" name="organizationId" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请选择所属体育局!' }]">
          <a-tree-select v-model:value="hallEditForm.organizationId" placeholder="请选择所属体育局" show-Line
            :tree-data="orgSource" allowClear :replace-fields="{
        children: 'child',
        label: 'name',
        key: 'id',
        value: 'id',
      }" @change="onselect">
          </a-tree-select>
        </a-form-item>
        <a-form-item label="开放时间" name="openTimeMetric" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请选择开放时间!' }]">
          <!-- //开放时间单位1天2周3月4年 -->
          <a-select v-model:value="hallEditForm.openTimeMetric" placeholder="请选择开放时间" :options="optionsTime">
          </a-select>
        </a-form-item>
        <a-form-item label="营业时间" name="openDate" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请选择营业时间!' }]">
          <a-range-picker show-time v-model:value="hallEditForm.openDate" valueFormat="YYYY-MM-DD HH:mm:ss"
            style="width: 100%" placeholder="请选择营业时间">
            <template #suffixIcon>
              <calendar-outlined />
            </template>
          </a-range-picker>
        </a-form-item>
        <a-form-item label="联系人" name="contactsName" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请输入联系人名称!' }]">
          <a-input v-model:value="hallEditForm.contactsName" placeholder="请输入联系人名称" />
        </a-form-item>
        <a-form-item label="联系电话" name="contactsPhone" has-feedback :labelCol="labelCol"
          :rules="[{ required: true, message: '请输入联系电话!', len: 11 }]">
          <a-input v-model:value="hallEditForm.contactsPhone" placeholder="请输入联系电话" />
        </a-form-item>
        <a-form-item name="businessLicenseUrl" label="营业执照" class="businessLicense" :labelCol="labelCol">
          <uploadImg v-if="showHallEdit" :ImgUrl="hallEditForm.businessLicenseUrl" :ImgType="3"
            @imgCallback="imgCallback">
          </uploadImg>
        </a-form-item>
      </a-form>
    </a-modal>
  </de-layout-content>
</template>
<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    align: "center",
    width: 70,
    // eslint-disable-next-line no-unused-vars
    customRender: (text, _record, index) => `${text.index + 1}`,
  },
  {
    title: "机构名称",
    dataIndex: "name",
    key: "name",
  },
  // {
  //   title: "开放状态",
  //   dataIndex: "openStatus",
  //   key: "openStatus",
  //   slots: { customRender: "openStatus", action: "openStatus" },
  // },
  {
    title: "审批状态",
    dataIndex: "examineStatus",
    key: "examineStatus",
    slots: { customRender: "examineStatus", action: "examineStatus" },
  },
  {
    title: "所在城市",
    dataIndex: "addressName",
    key: "addressName",
  },
  {
    title: "社会信用代码/注册号",
    dataIndex: "socialCreditCode",
    key: "socialCreditCode",
  },
  {
    title: "联系人",
    dataIndex: "contactsName",
    key: "contactsName",
  },
  {
    title: "联系电话",
    dataIndex: "contactsPhone",
    key: "contactsPhone",
  },
  {
    title: "申请时间",
    dataIndex: "createTime",
    key: "createTime",
    customRender: function (record) {
      var val = record.text;
      return val ? moment(val).format("yyyy-MM-DD HH:mm:ss") : "";
    },
  },
  {
    title: "操作",
    dataIndex: "tags",
    key: "tags",
    width: 200,
    align: "center",
    slots: { customRender: "tags", action: "tags" },
  },
];
// 开放时间单位1天2周3月4年
const optionsTime = [
  {
    value: 1,
    label: "天",
  },
  {
    value: 2,
    label: "周",
  },
  {
    value: 3,
    label: "月",
  },
  {
    value: 4,
    label: "年",
  },
];
import moment from "moment";
import { message } from "ant-design-vue";
import AdministrativeArea from "@/components/administrativeArea/administrativeArea.vue";
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import * as API_Mechanism from "@/api/system/mechanism";

export default {
  name: "mechanism",
  setup() { },
  components: { AdministrativeArea, uploadImg },
  data() {
    return {
      showTime: {
        format: "HH:mm:ss",
        defaultValue: [
          moment("00:00:00", "HH:mm:ss"),
          moment("23:59:59", "HH:mm:ss"),
        ],
      },
      Cheight: document.documentElement.clientHeight - 200 + "px",
      showFormArea: true,
      form: {
        name: undefined, //场馆名称
        contactInfo: undefined, //联系人姓名or电话
        examineStatus: undefined, //审批状态1待审批2通过3拒绝
        address: undefined, //地址
        addDate: [],
        createTimeFrom: undefined, //创建时间开始
        createTimeTo: undefined, //创建时间结束
        page: 1,
        size: 10,
      },
      operationType: "",
      showApproved: false,
      approvedForm: {
        startTime: null, //有效期开始时间
        endTime: null, //有效期结束时间
        remark: "", //审批备注
      },
      approvedRules: {
        validityPeriod: [
          {
            validator: (rule, value, callback) => {
              if (this.operationType == 'refuse') {
                callback();
                return;
              }
              if (!this.approvedForm.startTime || !this.approvedForm.endTime) {
                callback(new Error('请选择有效期'));
                return;
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },
      approvedNote: "", //审批备注
      //设置审批人
      showSetExamineUser: false,
      examineUser: {
        userOptions: [],
        userId: undefined,
        hallId: undefined,
      },
      //场馆编辑
      showHallEdit: false,
      optionsTime,
      hallEditForm: {
        id: 2, //场馆id
        name: undefined,
        socialCreditCode: undefined,
        address: undefined, //地址
        area: 200.2, //面积
        capacity: 400, //容量
        detailAddress: undefined, //详细地址
        organizationId: undefined, //组织结构id
        openTimeStart: undefined, //开发时间开始
        openTimeEnd: undefined, //开放时间结束
        openTimeMetric: 1, //开放时间单位1天2周3月4年
        businessLicenseUrl: undefined, //营业执照地址
        contactsName: undefined, //联系人
        contactsPhone: undefined, //联系电话
        openDate: [],
      },
      //table列表
      columns,
      total: 0,
      dataSource: [],
      orgSource: [],
      selectedRowKeys: [],
      // 24格栅格系统，label所占为 a
      labelCol: { sm: { span: 5 } },
      // approvalButton: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 判断复选框禁用
    selectable(row, index) {
      console.log(row);
      if (row.examineStatus != 1) {
        return false;
      } else {
        return true;
      }
    },

    //table初始化数据
    getData() {
      this.dataSource = [];
      var param = this.form;
      if (param.addDate.length > 0) {
        param["createTimeFrom"] = moment(param.addDate[0]).valueOf();
        param["createTimeTo"] = moment(param.addDate[1]).valueOf();
      }
      // param["page"] = this.pagination.current;
      // param["size"] = this.pagination.pageSize;
      API_Mechanism.hallList(param).then((res) => {
        if (res.code == 0 || res.code == 200) {
          var data = res.data;
          this.dataSource = data.data;
          this.total = data.total;
        }
      });
      // this.$axios.post("/api/v1/hall/list", param).then((res) => {
      //   if (res.code == 0 || res.code == 200) {
      //     var data = res.data;
      //     this.dataSource = data.data;
      //     this.pagination.total = data.total;
      //   }
      // });
    },
    //获取组织机构信息
    getOrgData() {
      return new Promise((resolve, reject) => {
        var param = {
          name: undefined,
          status: 1,
        };
        API_Mechanism.structureList(param).then((res) => {
          if (res.code == 0 || res.code == 200) {
            var data = res.data;
            this.orgSource = data;
            resolve(res);
          }
        });
      });
    },
    selectable(row, index) {
      if (row.examineStatus == 2) {
        return false;
      } else {
        return true;
      }
    },

    isRender(row) {
      if (row.row.examineStatus == 2) {
        return "disabled-column";
      }
    },

    //form按钮操作
    btnOperation(type) {
      let _that = this;
      _that.operationType = type;
      if (type == "search") {
        _that.getData();
      }
      if (type == "reload") {
        _that.showFormArea = false;
        this.$nextTick(() => {
          _that.showFormArea = true; //重建组件
          _that.form = {
            name: undefined, //场馆名称
            contactInfo: undefined, //联系人姓名or电话
            examineStatus: undefined, //审批状态1待审批2通过3拒绝
            address: undefined, //地址
            addDate: [],
            createTimeFrom: undefined, //创建时间开始
            createTimeTo: undefined, //创建时间结束
          };
          _that.getData();
        });
      }
      //审批通过approved  审批拒绝refuse
      if (type == "approved" || type == "refuse") {
        if (_that.selectedRowKeys.length < 1) {
          message.error("请选择待审核的记录");
          return;
        }
        // else if (_that.selectedRowKeys.length != 1) {
        //   message.error("只能选择一条待审核的记录进行审核！");
        //   return;
        // }
        this.approvedForm = {
          startTime: null,
          endTime: null,
          remark: ''
        }
        this.$nextTick(() => {
          this.$refs.approvedRuls && this.$refs.approvedRuls.clearValidate();
        });
        this.approvedNote = ''
        this.showApproved = true;
      }
      //审批人设置
      if (type == "examineUser") {
        if (_that.selectedRowKeys.length < 1) {
          message.error("请选择需要设置审批人的记录");
          return;
        } else if (_that.selectedRowKeys.length != 1) {
          message.error("只能选择一条记录进行设置审批人！");
          return;
        }
        _that.examineUser.hallId = _that.selectedRowKeys[0];
        let param = {
          hallId: _that.selectedRowKeys[0], //场馆id
          userName: undefined, //用户名 可不填 模糊搜索
        };

        API_Mechanism.examineUserList(param).then((res) => {
          if (res.code == 0 || res.code == 200) {
            let data = res.data;
            let user = [];
            data.forEach((item) => {
              user.push({
                value: item.id,
                label: item.name,
              });
            });
            _that.examineUser.userOptions = user;
            _that.showSetExamineUser = true;
          }
        });
      }
    },

    //审批或拒绝场馆入驻
    approved(type) {
      let _that = this;
      let examineStatus = 2;
      //审批状态
      if (type == "refuse") {
        examineStatus = 3;
      }
      if (type == "refuse" && _that.approvedNote.length < 1) {
        message.error("请填写拒绝原因");
        return;
      }
      let param = [];
      let baseParam = {
        examineStatus: examineStatus, //审批状态2通过3拒绝
        remark: _that.approvedForm.remark, //备注
      };
      //审批通过时附带有效期时间戳
      if (type == "approved") {
        baseParam.startTime = _that.approvedForm.startTime
          ? new Date(_that.approvedForm.startTime).getTime()
          : null;
        baseParam.endTime = _that.approvedForm.endTime
          ? new Date(_that.approvedForm.endTime).getTime()
          : null;
      }
      if (_that.selectedRowKeys.length > 1) {
        _that.selectedRowKeys.forEach((ele, i) => {
          param.push({
            ...baseParam,
            hallId: ele.id, //场馆id
          });
        });
      } else {
        param[0] = {
          ...baseParam,
          hallId: _that.selectedRowKeys[0].id, //场馆id
        };
      }
      API_Mechanism.batchApproval(param).then((res) => {
        if (res.code == 0 || res.code == 200) {
          _that.selectedRowKeys = [];
          _that.getData();
          _that.showApproved = false;
          message.success("操作成功");
        }
      });
    },

    //设置审批人
    setExamineUser() {
      let _that = this;
      _that.$refs.examineUserRuls
        .validate(["userId"])
        .then((ex) => {
          let param = {
            userId: _that.examineUser.userId, //审批人id
            hallId: _that.examineUser.hallId, //场馆id
          };
          API_Mechanism.setExamineUser(param).then((res) => {
            if (res.code == 0 || res.code == 200) {
              _that.selectedRowKeys = [];
              message.success("设置成功");
            }
          });
          // _that.$axios.post("/api/v1/hall/setExamineUser", param).then((res) => {
          //   if (res.code == 0 || res.code == 200) {
          //     _that.selectedRowKeys = [];
          //     message.success("设置成功");
          //   }
          // });
        })
        .catch((e) => {
          message.error(e);
        });
    },
    //修改开放状态
    setOpenStatus(record) {
      let _that = this;
      let param = {
        id: record.id, //场馆id
        openStatus: record.openStatus, //开放状态0关闭1开放
      };
      API_Mechanism.setOpenStatus(param).then((res) => {
        if (res.code == 0 || res.code == 200) {
          message.success("状态修改成功");
        }
      });
      // _that.$axios.post("/api/v1/hall/setOpenStatus", param).then((res) => {
      //   if (res.code == 0 || res.code == 200) {
      //     message.success("状态修改成功");
      //   }
      // });
    },
    //列表按钮操作
    hallAddEdit(type, record) {
      let _that = this;
      //详情
      if (type == "detail") {
        _that.$router.push({
          name: "mechanismHallDetail",
          query: {
            id: record.id,
          },
        });
      }
      if (type == "edit") {
        Promise.all([_that.getOrgData()]).then((el) => {
          _that.hallEditForm = {
            id: record.id, //场馆id
            name: record.name,
            socialCreditCode: record.socialCreditCode,
            address: record.address, //地址
            area: record.area, //面积
            capacity: record.capacity, //容量
            detailAddress: record.detailAddress, //详细地址
            organizationId: record.organizationId, //组织结构id
            openTimeStart: record.openTimeStart, //开发时间开始
            openTimeEnd: record.openTimeEnd, //开放时间结束
            openTimeMetric: record.openTimeMetric, //开放时间单位1天2周3月4年
            businessLicenseUrl: record.businessLicenseUrl, //营业执照地址
            contactsName: record.contactsName, //联系人
            contactsPhone: record.contactsPhone, //联系电话
            openDate: record.openTimeStart
              ? [
                moment(record.openTimeStart).format("YYYY-MM-DD HH:mm:ss"),
                moment(record.openTimeEnd).format("YYYY-MM-DD HH:mm:ss"),
              ]
              : [],
          };
          _that.showHallEdit = true;
        });
      }
    },
    maintainHall() {
      let _that = this;
      let form = _that.hallEditForm;
      if (!form.address || form.address.length < 1) {
        message.error("请选择所在地区！");
        return;
      }
      if (!form.businessLicenseUrl || form.businessLicenseUrl.length < 1) {
        message.error("营业执照信息不能为空！");
        return;
      }
      _that.$refs.hallRuls
        .validate([
          "socialCreditCode",
          "name",
          "detailAddress",
          "area",
          "capacity",
          "organizationId",
          "contactsName",
          "contactsPhone",
          "openDate",
        ])
        .then(() => {
          let param = _that.hallEditForm;
          if (param.openDate.length > 0) {
            param["openTimeStart"] = moment(param.openDate[0]).valueOf();
            param["openTimeEnd"] = moment(param.openDate[1]).valueOf();
          }
          API_Mechanism.hallEdit(param).then((res) => {
            if (res.code == 0 || res.code == 200) {
              _that.getData();
              _that.showHallEdit = false;
            }
          });
          // this.$axios.post("/api/v1/hall/edit", param, true).then((res) => {
          //   if (res.code == 0 || res.code == 200) {
          //     _that.getData();
          //     _that.showHallEdit = false;
          //   }
          // });
        })
        .catch((e) => { });
    },
    //场馆删除
    handleDelete(record) {
      let _that = this;
      let param = {
        id: record.id,
      };
      API_Mechanism.hallDel(param).then((res) => {
        if (res.code == 0 || res.code == 200) {
          _that.getData();
        }
      });
      // _that.$axios.post("/api/v1/hall/del", param, true).then((res) => {
      //   if (res.code == 0 || res.code == 200) {
      //     _that.getData();
      //   }
      // });
    },
    //控制checkbox是否显示隐藏
    getCheckboxProps(record) {
      // disabled  hidden  display:none
      if (record.examineStatus !== 1) {
        return { disabled: true };
      } else {
        return { disabled: false };
      }
    },
    //表选择事件
    onSelectChange(rowKeys, selectedRows) {
      console.log(rowKeys);
      // if (rowKeys.length > 0) {
      //   this.approvalButton = true;
      // } else {
      //   this.approvalButton = false;
      // }
      this.selectedRowKeys = rowKeys;
    },
    //form所在城市回调
    formTreeValue(treeVal) {
      this.form.address = treeVal;
    },
    hallFormTreeValue(treeVal) {
      this.hallEditForm.address = treeVal;
    },
    imgCallback(imgUrl) {
      this.hallEditForm.businessLicenseUrl = imgUrl;
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectedRowKeys = val
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .disabled-column .el-checkbox__input {
  display: none;
}

.businessLicense {
  margin-bottom: -15px;
}

.approvalButton {
  display: inline-flex;
  margin-left: 20px;

  .ant-btn {
    height: 32px;
  }
}
</style>
